/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type RtmPCCItemStatus = typeof RtmPCCItemStatus[keyof typeof RtmPCCItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RtmPCCItemStatus = {
  NoLinkSent: 'NoLinkSent',
  Pending: 'Pending',
  Sent: 'Sent',
  Completed: 'Completed',
  Expired: 'Expired',
  Skipped: 'Skipped',
  Unknown: 'Unknown',
} as const;
